import { ReactNode } from 'react';

export const ErrorWraper = ({
  message,
  children,
}: {
  message?: string;
  children?: ReactNode;
}) => {
  return (
    <div>
      {children}
      <p className="flex items-center pl-2 text-[12px] text-red-500">
        {message ? message : ''}
      </p>
    </div>
  );
};
